<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "SG-SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "SG-SST",
          active: true,
        },
      ],
      text: `
         ... `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
           
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">SG SST</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1"
                    >¿Qué es SG SST?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >¿Quién es el responsable del SST?</b-list-group-item
                  >
                 <!--   <b-list-group-item href="#list-item-3"
                    ></b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    > </b-list-group-item
                  >
                   <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <h4 id="list-item-1">¿Qué es SG SST?     </h4>
                  La definición del sistema de gestión de SST (SG-SST), está incluida en el Artículo 2.2.4.6.4 del Decreto 1072 de 2015: <br/> <br/>
                  “El Sistema de Gestión de la Seguridad y Salud en el Trabajo - SG-SST - consiste en el desarrollo de un proceso lógico y por etapas, basado en la mejora continua y que incluye la política, la organización, la planificación, la aplicación, la evaluación, la auditoría y las acciones de mejora con el objetivo de anticipar, reconocer, evaluar y controlar los riesgos que puedan afectar la seguridad y la salud en el trabajo”.
                  <br/>En resumen, este SG-SST es un proceso ordenado que permitirá a la empresa identificar y evaluar de manera permanente todos los peligros y riesgos que se presenten en las áreas de trabajo y presentar alternativas de control para evitar accidentes, enfermedades y para promover el estado de salud de los trabajadores. 
                  <br/>En la siguiente imagen se muestra el ciclo del Sistema de Gestión desde el Planear, Hacer, Verificar y Actua <br/><br/><br/>
                  <img style="position: center;" src="@/assets/images/imgBaseConocimiento.png" width="780" height="481">
                  <h4 id="list-item-2">¿Quién es el responsable del SST?  </h4>
                  <p>Es el encargado de implementar los requerimientos del sistema de gestión, dentro de sus funciones están: <br> -Llenar los formatos contenidos en el software, de acuerdo a los que apliquen a la empresa. 
                  <br/> -Montar los documentos al software. <br/> -Hacer las correcciones solicitados por el Responsable del diseño de SST y subirlas de nuevo al software. <br/> -Programar reuniones, capacitaciones, inducciones y/o reinducciones. 
                   <br/> -Llevar registro de asistencia en las capacitaciones. 
                   <br/> -Llevar a cabo las tareas y actividades asignadas por el Responsable del diseño de SST. 
                   <br/> -Recibir y dar trámite a los requerimientos presentados por los diferentes comités. 
                   <br/> -Dar cumplimiento a la norma. 
                   <br/> -Comunicar a la dirección las deficiencias detectadas. 
                    <br/>-Difundir las medidas de emergencia contempladas en el plan de emergencia de la organización 
                    <br/>-Velar por el cumplimiento de la norma. 
                    <br/>-Desarrollar las actividades de promoción y prevención. 
                    <br/>-Garantizar la realización de las autoevaluaciones de los estándares mínimos contenidos en la resolución 0312 de 2019 y reportarlos los resultados a las autoridades correspondientes.

                    </p>
                  <!-- <h4 id="list-item-3">DEFINICIONES</h4>
                  <p>...</p>
                  <h4 id="list-item-4">ACTIVIDADES</h4>
                  <p>...</p>
                 <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
